<template>
  <li>
    <button
      type="button"
      :class="[{ 'justify-between !px-0 !text-base': isActiveLocation && type === 'big' }]"
      class="flex w-full items-center gap-1 px-4 py-1.5 text-left text-sm"
    >
      {{ getLocationName(value) }}
      <UiIcon v-if="isActiveLocation" name="check" class="mr-2 size-3 text-icon-primary" />
    </button>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { UiIcon } from '@/6_shared/ui'
import { getLocationName } from '../lib'
import type { Location } from '../model'

type PropType = {
  value: Location
  currentLocation?: Location
  type?: 'big' | 'small'
}

const props = withDefaults(defineProps<PropType>(), {
  currentLocation: undefined,
  type: 'small'
})

const isActiveLocation = computed(
  () => props.currentLocation && props.currentLocation.id === props.value.id
)
</script>
